import React from 'react';
import { Helmet } from 'react-helmet';
import Section1 from './Section1';
import Section2 from './Section2';
import Section4 from './Section4';
import Section5 from './Section5';
import Section6 from './Section6';
import Section7 from './Section7';
import Section8 from './Section8';
import Section9 from './Section9';
import Section10 from './Section10';
import Section11 from './Section11';

export default function ShopifyPlus() {
  return (
    <div className="ShopifyPlus pt-[160px] sm:pt-0">
      <Helmet>
        <title>Shopify Plus Development Agency | Mean3</title>
        <meta
          name="description"
          content="Mean3 is a leading Shopify Plus development agency, specializing in custom solutions to enhance your e-commerce business. Contact us for expert Shopify Plus services."
        />
      </Helmet>

      <Section1 />
      <Section2 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Section7 />
      <Section8 />
      <Section9 />
      <Section10 />
      <Section11 />
    </div>
  );
}
